export default __webpack_public_path__ + "static/media/placeholder_dummy2016-fotograf03-mobile-de.d429ef28.png";